module.exports = __webpack_public_path__ + "img/36_13.5d1bd075.png";